import { forwardRef } from "react";
import styleSheet from "./style.module.scss";
import { InputFormProps } from "./orb-textarea-interface";
import ObrErrorMessage from "../orb-error-message";

const OrbTestArea = (props: InputFormProps) => {
  const {
    placeholder = "",
    onChange,
    handleFocus,
    className = "",
    value,
    rows=3,
    label,
    showError = true,
    errorMessage ='',
    ...rest
  } = props;

  return (
    <div>
      {label &&
                    <p className="mb-1 text-white mohave main-font">{label}</p>}
      <textarea
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        onFocus={handleFocus}
        className={`${styleSheet.dark} mohave`}
        {...rest}
        rows={rows}
        cols={50}
      />

      {showError && (
        <div
          className={`${styleSheet.error} d-flex justify-content-end `}
        >
             
          <ObrErrorMessage message={errorMessage} />
        </div>
      )}
    </div>
  );
};

export default OrbTestArea;
